// @module C3.ShoppingExtensions.ManufacturerPage
define('C3.ShoppingExtensions.Manufacturer.SubCategory.CirclesView'
,	[
	'c3_shoppingextensions_manufacturer_subcategory_circles.tpl'
	
	,	'SCView'
	//,   'C3.ShoppingExtensions.Carousel.View'
	,   'AjaxRequestsKiller'
	//,	'Backbone'
	,   'GlobalViews.Breadcrumb.View'
	,   'Utils'
	,   'Backbone.CollectionView'
	,   'Facets.CategoryCell.View'
    ]
, function (
	c3_shoppingextensions_manufacturer_subcategory_circles_tpl
	
	,	SCViewModule
	//,   CarouselView
	,   AjaxRequestsKiller
	//,	Backbone
	,   GlobalViewsBreadcrumbView
	,   Utils
	,   BackboneCollectionView
	,   FacetsCategoryCellView
)
{
    'use strict';

    var SCView = SCViewModule.SCView;

     function SubCategoryCirclesPageView (options) {
     	SCView.call(this, options);

     	this.template = c3_shoppingextensions_manufacturer_subcategory_circles_tpl;
        this.options = options;
	   this.application = options.application;
	   this.model = options.model;
	  // console.log(options)
     }

     SubCategoryCirclesPageView.prototype = Object.create(SCView.prototype);
     SubCategoryCirclesPageView.prototype.constructor = SubCategoryCirclesPageView;


     SubCategoryCirclesPageView.prototype.render = function () {
    	SCView.prototype.render.call(this);
    	
    }

    SubCategoryCirclesPageView.prototype.getContext = function () {
    	//console.log(this.model.get('thumbnailurl'))
    	return {
				thumbnailURL : this.model.get('thumbnailurl'),
				fullURL : this.model.get('fullurl'),
				name :  this.model.get('name')
			};
    }

     return SubCategoryCirclesPageView;

});
